import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useOrg } from "./OrgContext";

/**
 * Route guard for org-admin-only sections (the Team tab). A non-admin who
 * deep-links to `/orgs/:orgId/members` is redirected to the Organization tab.
 * The tab bar already hides Team from non-admins and its endpoints return 403
 * to them, so this guard covers a typed URL.
 */
export function RequireOrgAdmin({ children }: { children: ReactNode }): ReactNode {
  const { orgId, isOrgAdmin } = useOrg();
  if (!isOrgAdmin) return <Navigate to={`/orgs/${orgId}/organization`} replace />;
  return <>{children}</>;
}
